import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../../../configs/colors';

export const StatsContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  gap: '10px',
  padding: '8px 20px 12px',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  background: `linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%)`,
  '&::-webkit-scrollbar': {
    display: 'none',
  },
});

interface StatTileProps {
  active?: boolean;
}

export const StatTile = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<StatTileProps>(({ active }) => ({
  flex: '0 0 auto',
  minWidth: '90px',
  maxWidth: '90px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: active ? 'rgba(255, 255, 255, 0.35)' : 'rgba(255, 255, 255, 0.15)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  borderRadius: '10px',
  padding: '8px 10px',
  border: active ? `2px solid ${COLORS.White}` : '1px solid rgba(255, 255, 255, 0.2)',
  boxShadow: active ? '0 0 12px rgba(255, 255, 255, 0.3)' : 'none',
  cursor: 'pointer',
  transition: 'all 0.25s ease',
  textAlign: 'center',
  '&:active': {
    transform: 'scale(0.95)',
    background: 'rgba(255, 255, 255, 0.25)',
  },
}));

export const StatNumber = styled(Box)({
  fontWeight: 700,
  fontSize: '1.2rem',
  lineHeight: 1,
  color: '#fff',
  marginBottom: '2px',
});

interface StatLabelProps {
  active?: boolean;
}

export const StatLabel = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<StatLabelProps>(({ active }) => ({
  fontWeight: active ? 600 : 500,
  fontSize: '0.62rem',
  textTransform: 'uppercase',
  letterSpacing: '0.8px',
  color: active ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.65)',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  transition: 'all 0.25s ease',
}));
